module.exports = __webpack_public_path__ + "static/media/Simple_Item_Frame@3x.2429e732.png";